<template>
<div class="pull">
    <van-pull-refresh v-model="pull.isLoading" @refresh="onRefresh">
        <van-list v-model="pull.loading" :finished="pull.finished" loading-text="让资本赋能企业成长" :finished-text="page.rowCount ? '— 我是有底线的 —' : ''" @load="onLoad" :immediate-check="false"
                  :error.sync="pull.error" error-text="请求失败，点击重新加载">
            <slot></slot>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'pull',
    data() {
        return {
        }
    },
    props: ['page', 'pull'],
    mounted() {
    },
    methods: {
        onRefresh() {
            if ($(document).scrollTop() === 0 || $(document).scrollTop() === '0') {
                this.setLoading(true)
                this.pull.finished = false
                this.page.page = 1
                this._getList()
            } else {
                this.pull.isLoading = false
            }
        },
        onLoad() {
            if (this.page.page < this.page.pageCount) {
                this.page.page++
                this._getList()
            } else {
                this.pull.finished = true
                this.pull.loading = false
            }
        },
        _getList () {
            this.$emit('getList')
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.pull {
    .van-list__finished-text{
       background: $c-global;
       font-size: 0.24rem;
    }
}
</style>
